import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {
    view: boolean;
}

const ManageJournalDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.MAGAZINE}
            view={view}
            menu_name={t('จัดการวารสาร')}
            menu_name_detail={t("เพิ่มวารสาร")}
            menu_name_detail_edit={t("รายละเอียดวารสาร")}
            menu_path_name={routeName.e_library.manage_journal}
        />
    )
}

export default ManageJournalDetail